function comparePlaces(a, b) {
    return (Number(a.sortOrder) || 0) - (Number(b.sortOrder) || 0)
        || String(a.name).localeCompare(String(b.name))
}

// Resolve the dashboard transfer catalog for one Storyblok tour. Keeping this pure
// makes the dashboard link the only migration seam: an unavailable catalog, inactive
// activity, or route-less activity all fall straight back to Storyblok transfer_costs.
export function matchTourTransfers(catalog, story) {
    if (!catalog || !Array.isArray(catalog.places) || !Array.isArray(catalog.routes))
        return null

    const activePlaces = catalog.places.filter(place => place.active)
    const activities = activePlaces.filter(place => place.type === 'activity')
    const activity = activities.find(place => story.uuid && place.storyblokUuid === story.uuid)
        || activities.find(place => story.fullSlug && place.storyblokSlug === story.fullSlug)
    if (!activity)
        return null

    // Tour quotes always ask for pickup -> activity. A route may therefore end at the
    // activity, or start there only when the quote engine is allowed to reverse it.
    const routes = catalog.routes.filter(route =>
        route.active
        && (route.toPlaceId === activity.id || (route.fromPlaceId === activity.id && route.bidirectional)),
    )
    if (!routes.length)
        return null

    const pickupIds = new Set()
    for (const route of routes) {
        const endpointId = route.fromPlaceId === activity.id ? route.toPlaceId : route.fromPlaceId
        pickupIds.add(endpointId)
        for (const place of activePlaces) {
            if (place.areaId === endpointId)
                pickupIds.add(place.id)
        }
    }

    const pickupPlaces = activePlaces
        .filter(place => pickupIds.has(place.id) && place.id !== activity.id)
        .sort(comparePlaces)
    if (!pickupPlaces.length)
        return null

    const routeIds = new Set(routes.map(route => route.id))
    const hasSeasonalPricing = (catalog.routePrices || []).some(row =>
        routeIds.has(row.routeId) && (row.seasonStart || row.seasonEnd),
    )

    return {
        catalog,
        activityId: activity.id,
        pickupPlaces,
        hasSeasonalPricing,
    }
}
